import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2, Mail } from 'lucide-react';
import {
    Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';

/** "Send now" for the one-pager — same attachment path scheduled reports use. */
export const SendOnePagerDialog = ({ open, onOpenChange, onSend }) => {
    const { t } = useTranslation();
    const [to, setTo] = useState('');
    const [sending, setSending] = useState(false);

    const emails = to.split(',').map((e) => e.trim()).filter(Boolean);

    const submit = async () => {
        setSending(true);
        const ok = await onSend(emails);
        setSending(false);
        if (ok) {
            setTo('');
            onOpenChange(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent data-testid="calc-send-dialog">
                <DialogHeader>
                    <DialogTitle>{t('salesCalc.send.title', 'Email the one-pager')}</DialogTitle>
                    <DialogDescription>
                        {t('salesCalc.send.hint', 'Sends the same branded PDF immediately, with your footer contact block.')}
                    </DialogDescription>
                </DialogHeader>
                <div className="space-y-1.5">
                    <Label htmlFor="calc-send-to">{t('salesCalc.send.to', 'Send to')}</Label>
                    <Input id="calc-send-to" type="text" value={to}
                        placeholder={t('salesCalc.send.toPlaceholder', 'name@company.com')}
                        onChange={(e) => setTo(e.target.value)}
                        data-testid="calc-send-to-input" />
                </div>
                <DialogFooter>
                    <Button onClick={submit} disabled={sending || !emails.length} data-testid="calc-send-submit-btn">
                        {sending ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Mail className="w-4 h-4 mr-1.5" />}
                        {sending ? t('salesCalc.send.sending', 'Sending…') : t('salesCalc.send.submit', 'Send now')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default SendOnePagerDialog;
